import { vservice } from '@niknevis/vue-modules'

@vservice()
export class Obj {
  /*Pop an item from obj*/
  pop<T>(obj: T, item: keyof T): typeof item | typeof Error | false {
    for (let key in obj) {
      if (key !== item) continue
      if (!delete obj[key]) throw new Error()

      return key
    }

    return false
  }

  get(object: object, keys: string[] | string, defaultVal = undefined) {
    keys = Array.isArray(keys) ? keys : keys.split('.')
    object = object[keys[0]]
    if (object && keys.length > 1) {
      return this.get(object, keys.slice(1))
    }
    return object === undefined ? defaultVal : object
  }

  filter(obj: object, predicate) {
    const result = new Map()

    for (const [key, value] of Object.entries(obj)) {
      if (predicate(value, key)) {
        result.set(key, value)
      }
    }

    return Object.fromEntries(result)
  }

  map(obj: object, predicate) {
    return Object.keys(obj).reduce((acc, key) => {
      return {
        ...acc,
        [key]: predicate(obj[key], key)
      }
    }, {})
  }

  shallowEqual(object1, object2) {
    const keys1 = Object.keys(object1)
    const keys2 = Object.keys(object2)

    if (keys1.length !== keys2.length) {
      return false
    }

    for (let key of keys1) {
      if (object1[key] !== object2[key]) {
        return false
      }
    }

    return true
  }

  isEmpty(obj) {
    return Object.keys(obj).length === 0
  }
}
